import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Card = styled.div`
  height: 68px;
  background: ${myPalette.white.main};
  border-radius: 8px;
  box-shadow: 0 0 5px 0 rgba(0, 21, 70, 0.1);
  padding: 16px;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const Title = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${myPalette.midnightBlue.main};
  cursor: pointer;
  margin-left: 12px;
`

export const IonIconWrapper = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  background: ${myPalette.midnightBlue.main};
`
